<template>
  <div class="nx-searcher-filter-sections pr-4">
    <nx-entity-selector
      :entity="entity"
      :label="$t('message.searcher.filters.values.' + entity)"
      :customFilters="customFilters"
      :limit="limit"
      :disabled="disabled"
      :itemTextKey="itemTextKey"
      :itemValueKey="itemValueKey"
      :allowEditItems="allowEditItems"
      :formatedItems="formatedItems"
      :value="formatedItems"
      :loadingItem="loadingItem"
      v-bind="$attrs"
      @input="updateFilter"
    />
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import Filter from './Filter';
import api from '@/modules/searcher/api';


export default {
  name: 'nx-searcher-filter-entity',
  extends: Filter,
  data: () => ({ formatedItems: [], loadingItem: false }),
  props: {
    entity: String,
    limit: Number,
    itemTextKey: String,
    itemValueKey: String,
    allowEditItems: Boolean,
    customFilters: Object,
    value: {
      type: [Number, Array],
      default: () => [],
    },
  },
  computed: {
    multiple() {
      return this.limit !== 1;
    },
  },
  methods: {
    async formatValues(val) {
      this.loadingItem = true;
      if (this.multiple && isArray(val)) {
        this.formatedItems = await Promise.all(
          // comprobamos si el valor es un número o no porque val es un array que puede contener
          // number -> cuando se monta el componente y recibe en su prop `value` el valor del filtro
          //  como parámetro en la url
          // object { ..., id } -> cuando el componente de entity selector emite un item seleccionado
          val.map(value => api.fetch(this.entity, isNaN(value) ? value.id : value, this.searchTokenSource)),
        );
      } else {
        this.formatedItems = await api.fetch(this.entity, isNaN(val) ? val.id : val, this.searchTokenSource);
      }
      this.loadingItem = false;
    },
    getValue(v) {
      if (!v) {
        return null;
      }
      if (isNaN(v) && typeof v === 'object') {
        return v.id;
      }
      return v;
    },
    async updateFilter(value) {
      if (isEmpty(value)) {
        this.$emit('input', this.filter, []);
        this.formatedItems = [];
        return;
      }
      this.$emit('input', this.filter, this.multiple ? value.map(val => this.getValue(val)) : this.getValue(value));
    },
  },
  watch: {
    value: {
      async handler(value) {
        if (!isEmpty(value)
          || (typeof value === 'number' && value > 0)
        ) {
          this.formatValues(value);
        }
      },
      immediate: true,
    },
  },
};
</script>
